import React, { FunctionComponent, JSXElementConstructor } from 'react'
import cn from 'classnames'
import s from './text.module.css'
import { TextProps, TextVariant } from '.'

const Text: FunctionComponent<TextProps> = ({ style, className = '', variant = 'bodyOne', children, html }) => {
  const componentsMap: {
    [P in TextVariant]: React.ComponentType<any> | string
  } = {
    bodyOne: 'div',
    bodyTwo: 'div',
    caption: 'span',
    headingOne: 'h1',
    headingTwo: 'h2',
    headingThree: 'h3',
    headingFour: 'h4',
    headingFive: 'h5',
    headingSix: 'h6',
  }

  const Component: JSXElementConstructor<any> | React.ReactElement<any> | React.ComponentType<any> | string =
    componentsMap![variant!]

  const htmlContentProps = html
    ? {
        dangerouslySetInnerHTML: { __html: html },
      }
    : {}

  return (
    <Component
      className={cn(
        s.root,
        {
          [s.bodyOne]: variant === 'bodyOne',
          [s.bodyTwo]: variant === 'bodyTwo',
          [s.caption]: variant === 'caption',
          [s.headingOne]: variant === 'headingOne',
          [s.headingTwo]: variant === 'headingTwo',
          [s.headingThree]: variant === 'headingThree',
          [s.headingFour]: variant === 'headingFour',
          [s.headingFive]: variant === 'headingFive',
          [s.headingSix]: variant === 'headingSix',
        },
        className,
      )}
      style={style}
      {...htmlContentProps}
    >
      {children}
    </Component>
  )
}

export default Text
